<template>
    <label class="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:pr-2">
        <RadioButton v-bind="primeVueProps" />
        <slot />
    </label>
</template>

<script>
import { computed, useAttrs } from 'vue';
/**
 * ERadio - Abstraction wrapper around PrimeVue's RadioButton
 *
 * Usage:
 *   <e-radio v-model="selected" native-value="option1">
 *     Option 1
 *   </e-radio>
 *   <e-radio v-model="selected" native-value="option2">
 *     Option 2
 *   </e-radio>
 *
 *   <e-radio v-model="size" native-value="small">
 *     Small
 *   </e-radio>
 *   <e-radio v-model="size" native-value="medium">
 *     Medium
 *   </e-radio>
 *   <e-radio v-model="size" native-value="large">
 *     Large
 *   </e-radio>
 *
 *   <e-radio v-model="choice" native-value="yes" type="is-success">
 *     Yes
 *   </e-radio>
 *   <e-radio v-model="choice" native-value="no" type="is-danger">
 *     No
 *   </e-radio>
 *
 * All Buefy b-radio props, events, and slots are supported.
 */
export default {
    name: 'ERadio',
    inheritAttrs: false,
    setup() {
        const attrs = useAttrs();

        const primeVueProps = computed(() => {
            const { 'native-value': nativeValue, ...rest } = attrs;
            return {
                ...rest,
                value: nativeValue,
                pt: {
                    box: ({ context }) => ({
                        class: context.checked
                            ? 'tw:border-primary tw:bg-white tw:w-5 tw:h-5 tw:rounded-full tw:border-2'
                            : 'tw:border-black tw:bg-white tw:w-5 tw:h-5 tw:rounded-full tw:border-2',
                    }),
                    icon: ({ context }) => ({
                        class: context.checked ? 'tw:bg-primary tw:rounded-full' : '',
                    }),
                },
            };
        });

        return { primeVueProps };
    },
};
</script>
